export default {"src":"/_next/static/media/avalanche.1b534485.svg","height":1504,"width":1503};